import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import PersonalInformationModelPopup from "components/modelpopup/PersonalInformationModelPopup";

const LeaveAttachment = ({fields, remove}) => {



  const handleDownloadAll = (data) => {
    
   
        if (!data || data.length === 0) {
            alert("No attachments available to download.");
            return;
          }
        
         
        
            // Create a temporary anchor element for downloading
            const link = document.createElement('a');
            link.href = data.url;
            link.target = "_blank";
        
            // Set file name or fallback to URL file name
            link.download = data.name || data.url.split('/').pop();
        
            // Trigger download
            document.body.appendChild(link);
            link.click();
        
            // Clean up the DOM
            document.body.removeChild(link);
         
 

  };


  return (
    <>
      <div className="tab-content">
        <div id="emp_profile" className="pro-overview tab-pane fade show active">            
          <div className="mail-attachments">
            <p>
                <i className="fa-solid fa-paperclip" /> {fields?.length} Attachments {" "}
          
            </p>
            <ul className="attachments clearfix">
            {fields?.length > 0 ? (
                    <>
                        {fields?.map((item, index) => (
                <ListItem
                id={item.id}
                key={index}
                item={item}
                download={handleDownloadAll}
                remove={remove}
                index={index}
                />
            ))}
                    </>
                    ) : (
                    <div></div>
                    )}

              

                
            </ul>
          </div>              
        </div>  

   
      </div>
      {/* Model Popup*/}
      <PersonalInformationModelPopup />
    </>
  );
};

export const ListItem = ({ item, key, remove, index }) => {
    console.log(index, "LLL")
    return(
    <li>
    <div className="attach-file">
        {
            item?.url.split(".").pop() == "pdf" ?
            <i className="fa-solid fa-file-pdf"></i>
        :
        <img style={{ height: '100px'}} src={item.url} alt="" />
        }
        
    </div>
    <div className="attach-info align-right d-flex justify-content-end ">
        {" "}
        {
          item?.url &&
          <Link to={item?.url} target="_blank" className="attach-filename" >
          <i className="fa-solid fa-eye"></i>
          </Link>
        }
        
        {/* <Link  className="attach-filename" onClick={() => remove(index)}  >
           <i className="attach-fileize fa-solid fa-trash"/>
        </Link>{" "}       */}
    </div>
</li>
  )};

export default LeaveAttachment;
